import { css } from 'emotion';

export const popup = css`
  width: 640px;
  position: relative;
`;

export const closeButton = css`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const iconContainer = css`
  margin: auto;
  position: relative;
  height: 80px;
  width: 70px;
  margin-top: 80px;
`;

export const traningsIcon = css`
  height: 80px;
  width: 70px;
`;

export const checkIcon = theme => css`
  position: absolute;
  bottom: -6px;
  right: -7px;
  width: 40px;
  height: 40px;
  fill: ${theme.color.green};
  background-color: white;
  border-radius: 20px;
`;

export const info = css`
  margin-top: 30px !important;
  text-align: center;
  font-weight: bold !important;
`;

export const exitButton = isMobile => css`
  display: block !important;
  margin: 30px auto 60px;
  ${isMobile
    ? `
    font-size: 16px;
    height: 32px;
  `
    : ''}
`;
